import axios, { AxiosResponse } from "axios";
import environment from "../config";
import TransactionsData from "../entities/TransactionsData";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export async function GetCollectionTransactions(fundCode?: number | string) {
  try {
    const body = {
      fundCode: null,
      // dateFrom: null,
      // dateTo: null,
    };
    const path =
      environment.BASE_URL + "MemberDetails/GetCollectionTransactions";
    const res: AxiosResponse<any> = await dal.post(path, body);
    if (
      axiosUtil.isSuccess(res) &&
      res?.data?.collectionTransactionData?.length
    ) {
      const transactionData = res.data.collectionTransactionData;
      return transactionData.sort(
        (a: TransactionsData, b: TransactionsData) => {
          return (
            new Date(b.dateValue).valueOf() - new Date(a.dateValue).valueOf()
          );
        }
      );
    }
    return [];
  } catch (err) {
    console.log(err);
  }
}
